export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      FunctionInfo: {
        FunctionId: 1,
        FunctionName: '見守り機能',
        DeliveryType: ' follow'
      }
    }
  }
}